import { deepAnalysisApi } from '../service';
import {
    FailedCheck,
    FetchOnPageSeoFailedChecksParams,
    SeoTestDetails,
    FetchOnPageSeoTestParams,
    FetchAffectedUrlsResponse,
    FetchAffectedUrlsParams,
} from './types';

const failedChecksApi = deepAnalysisApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchOnPageSeoFailedChecks: builder.query<FailedCheck[], FetchOnPageSeoFailedChecksParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/failed-checks/${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'FailedChecks', id: args.w_guid }],
        }),

        fetchOnPageSeoFailedDomainChecks: builder.query<FailedCheck[], FetchOnPageSeoFailedChecksParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/failed-checks/domain/${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'FailedChecks', id: args.w_guid }],
        }),

        fetchOnPageSeoTestDetails: builder.query<SeoTestDetails, FetchOnPageSeoTestParams>({
            query: (args) => {
                const { seo_test_key } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/seo-test/${seo_test_key}`,
                };
            },
        }),

        fetchAffectedUrls: builder.query<FetchAffectedUrlsResponse, FetchAffectedUrlsParams>({
            query: (args) => {
                const { w_guid, seo_test_key, limit, last_evaluated_key } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/affected-urls/${w_guid}/${seo_test_key}${limit ? `?limit=${limit}` : ''}${
                        last_evaluated_key ? `&last_evaluated_key=${last_evaluated_key}` : ''
                    }`,
                };
            },

            providesTags: (result, error, args) => [
                { type: 'AffectedUrls', id: `${args.w_guid}_${args.seo_test_key}` },
                { type: 'AffectedUrls', id: args.w_guid },
            ],
        }),
    }),
});

export const {
    useFetchOnPageSeoFailedChecksQuery,
    useFetchOnPageSeoTestDetailsQuery,
    useFetchAffectedUrlsQuery,
    useLazyFetchAffectedUrlsQuery,
    useFetchOnPageSeoFailedDomainChecksQuery,
} = failedChecksApi;
